// extracted by mini-css-extract-plugin
export default {"playContainer":"GamePlay_playContainer__053pB","fadeIn":"GamePlay_fadeIn__-sJC3"};